import { render, staticRenderFns } from "./riskFollowUp.vue?vue&type=template&id=1d23563e&scoped=true&"
import script from "./riskFollowUp.vue?vue&type=script&lang=ts&"
export * from "./riskFollowUp.vue?vue&type=script&lang=ts&"
import style0 from "./riskFollowUp.vue?vue&type=style&index=0&id=1d23563e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d23563e",
  null
  
)

export default component.exports